export var UsernameAttributes;
(function (UsernameAttributes) {
    UsernameAttributes["EMAIL"] = "email";
    UsernameAttributes["PHONE_NUMBER"] = "phone_number";
    UsernameAttributes["USERNAME"] = "username";
})(UsernameAttributes || (UsernameAttributes = {}));
//# sourceMappingURL=types.js.map